/**
 * =============================================================================
 * DESTELLO — EL ICONO DE "ESTO LO HA REDACTADO UNA IA"
 * =============================================================================
 * Tres estrellas de cuatro puntas: una grande y dos pequenas. Es el simbolo que
 * se ha vuelto convencion para el contenido generado por un modelo, y usarlo
 * ahorra una explicacion: quien lo ve ya sabe que lo de debajo no lo ha escrito
 * una persona.
 *
 * VA DIBUJADO A MANO porque Ant Design no lo tiene. Lo mas parecido de su
 * catalogo son estrellas de cinco puntas —que significan "favorito"— o el rayo,
 * que significa "rapido". Ninguno dice lo que hay que decir aqui, y un icono que
 * dice otra cosa es peor que no poner ninguno.
 *
 * `currentColor` a proposito: hereda el color del texto que lo acompana, asi que
 * funciona en la cabecera de una tarjeta, dentro de un boton primario o sobre
 * fondo oscuro sin tener que tocarlo. `aria-hidden` porque es decorativo: el
 * significado ya esta en el texto de al lado, y anunciarlo dos veces a un lector
 * de pantalla solo estorba.
 * =============================================================================
 */

import React from "react";

export function IconoDestello({ size = 16, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      style={{ verticalAlign: "-0.125em", ...style }}
    >
      {/* Destello grande, descentrado a la derecha */}
      <path d="M14.5 2.5c.2 3 .9 5 2.2 6.3 1.3 1.3 3.3 2 6.3 2.2-3 .2-5 .9-6.3 2.2-1.3 1.3-2 3.3-2.2 6.3-.2-3-.9-5-2.2-6.3-1.3-1.3-3.3-2-6.3-2.2 3-.2 5-.9 6.3-2.2 1.3-1.3 2-3.3 2.2-6.3z" />
      {/* Pequeno arriba a la izquierda */}
      <path d="M5 1.5c.1 1.5.45 2.5 1.1 3.15.65.65 1.65 1 3.15 1.1-1.5.1-2.5.45-3.15 1.1-.65.65-1 1.65-1.1 3.15-.1-1.5-.45-2.5-1.1-3.15C3.25 6.2 2.25 5.85.75 5.75c1.5-.1 2.5-.45 3.15-1.1C4.55 4 4.9 3 5 1.5z" />
      {/* Pequeno abajo a la izquierda */}
      <path d="M4.5 14.5c.08 1.2.36 2 .88 2.52.52.52 1.32.8 2.52.88-1.2.08-2 .36-2.52.88-.52.52-.8 1.32-.88 2.52-.08-1.2-.36-2-.88-2.52-.52-.52-1.32-.8-2.52-.88 1.2-.08 2-.36 2.52-.88.52-.52.8-1.32.88-2.52z" />
    </svg>
  );
}

export default IconoDestello;
